import type { HttpClient } from "@/shared/api/http";
import { platform } from "@/platform";
import { registerPushDevice } from "@/modules/sys/api/sysApi";
import {
  ensureWebPushDevice,
  type WebPushRegisterResult,
} from "@/modules/sys/push/webPushDevice";

/**
 * PWA keeps the local `web-{uuid}` token. The native shell registers the FCM/APNs token instead.
 */
export async function ensurePushDevice(http: HttpClient): Promise<WebPushRegisterResult> {
  if (!platform.isNative) return ensureWebPushDevice(http);

  const result = await platform.push.register();
  if (result.status !== "ok") return result.status === "denied" ? "denied" : result.status;
  if (isWebPlaceholder(result.deviceToken)) return "error";

  try {
    await registerPushDevice(http, {
      platform: result.platform,
      deviceToken: result.deviceToken,
      channelPref: "MOB",
    });
    return "ok";
  } catch {
    return "error";
  }
}

export function pushRegisterResultMessage(
  result: WebPushRegisterResult,
  native = platform.isNative,
): string | null {
  switch (result) {
    case "denied":
      return native
        ? "Không có quyền thông báo."
        : "Trình duyệt từ chối quyền thông báo.";
    case "unsupported":
      return native
        ? "Máy này chưa nhận được thông báo đẩy."
        : "Trình duyệt không hỗ trợ thông báo push.";
    case "error":
      return "Không đăng ký được thiết bị push.";
    default:
      return null;
  }
}

function isWebPlaceholder(token: string): boolean {
  return token.trim().toLowerCase().startsWith("web-");
}
